import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-readed-mail-icon',
  templateUrl: './communication-readed-mail.component.html'
})
export class CommunicationReadedMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
